import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useMemo } from 'react';
import classes from './rightColumn.module.css';

function RightColumn(_ref) {
  var group = _ref.group;

  var getColor = function getColor(groupName) {
    var bgColor;
    var color = '#fff';
    var border;

    switch (groupName) {
      case 'Gallery Dealer':
        bgColor = '#f2f2f2';
        color = '#3e3e3e';
        border = '1px solid #121111';
        break;

      case 'To the Trade':
        bgColor = '#121111';
        break;

      case 'Display Dealer':
        bgColor = '#F2F2F2';
        color = '#3e3e3e';
        break;

      default:
        bgColor = '#828282';
    }

    return {
      bgColor: bgColor,
      color: color,
      border: border
    };
  }; //TODO move sorting logic to hook to be used in StoreList too.


  var sortedGroup = useMemo(function () {
    return group === null || group === void 0 ? void 0 : group.map(function (item) {
      var sum = 0;

      if (item.name === 'Gallery Dealer') {
        sum += 6;
      } else if (item.name === 'Display Dealer') {
        sum += 3;
      } else if (item.name === 'To the Trade') {
        sum += 11;
      } else {
        sum += 1;
      }

      return _objectSpread(_objectSpread({}, item), {}, {
        sum: sum
      });
    }).sort(function (a, b) {
      if (a.sum > b.sum) {
        return -1;
      }

      if (a.sum < b.sum) {
        return 1;
      }

      return 0;
    });
  }, [group]);
  return React.createElement("div", {
    className: classes.rightColumn
  }, sortedGroup === null || sortedGroup === void 0 ? void 0 : sortedGroup.map(function (option) {
    var style = getColor(option.name);
    return React.createElement("div", {
      className: "flex mb-3 items-center",
      key: option.name
    }, React.createElement("div", {
      style: {
        backgroundColor: style.bgColor,
        color: style.color,
        border: style.border || 'none'
      },
      className: classes.option
    }, option.name === 'To the Trade' ? 'Trade Only' : option.name), React.createElement("div", {
      className: classes.info
    }, React.createElement("span", null, "i"), React.createElement("span", {
      className: classes.tooltiptext
    }, option.tooltip)));
  }));
}

export default RightColumn;